import React from 'react';
import CustomersState from './customersState/CustomersState';
import CustomersControlPanel from './components/CustomersControlPanel/CustomersControlPanel';
import Customers from './components/Customers/Customers';
import { ModalWindows } from './components/ModalWindows';
import CustomerFullInfoPage from '../CustomerFullInfo';
import style from './index.module.scss';

const CustomersPage: React.FC = () => {
	return (
		<CustomersState>
			<div className={style.container} data-test="CustomersPage">
				<CustomersControlPanel />
				<Customers />
				<ModalWindows />
				<CustomerFullInfoPage />
			</div>
		</CustomersState>
	);
};

export default CustomersPage;
